import React from "react";
// reactstrap components (레이아웃 호환을 위해 import 유지)
import firebase from "firebase.config";
import NewsletterPhonePreview from "components/NewsletterPhonePreview";

export default class Page2 extends React.Component {
  state = {
    isEmpty: true,

    headers: [
      {
        header: "",
        text: ""
        // text2: ""
      }
    ]
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  componentDidMount = () => {
    this.initialize();
  };

  initialize = () => {
    console.log("Page 2:");
    console.log("Global Obj: ", this.props.obj);

    var temp = this.state.headers;
    temp = this.props.obj[0].magazine1.page2;

    this.setState({
      headers: temp
    });
    console.log("Local Obj: ", this.state.magazine);
  };

  addHeader = () => {
    var temp = this.state.headers;

    temp.push({
      header: "",
      text: ""
      // text2: ""
    });

    this.setState({
      headers: temp
    });
  };

  deleteHeader = index => {
    let temp = this.state.headers;

    temp.splice(index, 1);

    this.setState({
      headers: temp
    });
  };

  handleChange = (event, index, key) => {
    console.log("Page 2 :", this.state.headers);
    let temp = this.state.headers;

    temp[index][key] = event.target.value;

    this.setState({ headers: temp });
  };

  // 단계 표시기 (현재 2단계: 본문 내용)
  renderSteps() {
    const steps = ["기본 정보", "본문 내용", "마무리 확인"];
    const current = 1;
    return (
      <ol className="mb-8 flex flex-wrap items-center gap-3">
        {steps.map((label, i) => (
          <li key={i} className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <span
                className={
                  "flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold " +
                  (i === current
                    ? "bg-sky-500 text-white shadow"
                    : i < current
                    ? "bg-sky-200 text-sky-700"
                    : "bg-gray-200 text-gray-500")
                }
              >
                {i + 1}
              </span>
              <span
                className={
                  "text-sm font-medium " +
                  (i === current ? "text-sky-600" : "text-gray-400")
                }
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <span className="hidden h-px w-8 bg-gray-300 sm:block" />
            )}
          </li>
        ))}
      </ol>
    );
  }

  render() {
    const items = this.props.obj[0].magazine1.page2;
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-6xl px-2 pb-10">
          {/* 안내 배너 */}
          <div className="mb-6 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-400 p-6 text-white shadow-lg">
            <h2 className="mb-2 text-2xl font-bold">📝 2단계 · 본문 내용</h2>
            <p className="text-sm leading-relaxed text-sky-50">
              두 번째 페이지에 담을 소식을 <span className="font-semibold">항목</span>
              별로 추가하세요. 항목마다 <span className="font-semibold">소제목</span>과{" "}
              <span className="font-semibold">내용</span>을 입력하면 됩니다. 다 쓰셨으면
              아래 <span className="font-semibold">[다음 단계로]</span> 버튼을 누르세요.
            </p>
          </div>

          {/* 단계 표시기 */}
          {this.renderSteps()}

          <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
            <div className="min-w-0 lg:flex-1">
          {/* 본문 항목 */}
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-1 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                ✎
              </span>
              <h3 className="text-lg font-bold text-gray-800">본문 항목</h3>
            </div>
            <p className="mb-4 ml-9 text-sm text-gray-500">
              예) 소제목 "동아리 모집" → 내용 "그림 동아리에서 신입 회원을
              모집합니다. 매주 수요일 오후 3시."
            </p>

            {items.length === 0 && (
              <div className="ml-9 mb-4 rounded-xl bg-amber-50 p-4 text-sm text-amber-700">
                아직 추가된 항목이 없습니다. 아래 <b>[+ 항목 추가]</b> 버튼을 눌러
                첫 번째 소식을 작성해 보세요.
              </div>
            )}

            <div className="space-y-5 sm:ml-9">
              {items.map((table, index) => (
                <div
                  key={index}
                  className="rounded-xl border border-gray-200 bg-gray-50/60 p-4"
                >
                  <div className="mb-3 flex items-center justify-between">
                    <span className="rounded-md bg-sky-500 px-2 py-0.5 text-xs font-bold text-white">
                      항목 {index + 1}
                    </span>
                    <button
                      type="button"
                      title="이 항목 삭제"
                      className="inline-flex items-center gap-1 rounded-lg border border-rose-200 bg-white px-3 py-1.5 text-xs font-medium text-rose-500 transition hover:bg-rose-50"
                      onClick={() => this.deleteHeader(index)}
                    >
                      🗑️ 삭제
                    </button>
                  </div>

                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    소제목
                  </label>
                  <input
                    type="text"
                    placeholder="예) 동아리 회원 모집"
                    defaultValue={table.header}
                    className={this.inputCls + " mb-3"}
                    onChange={event => this.handleChange(event, index, "header")}
                  />

                  <label className="mb-1 block text-xs font-semibold text-gray-600">
                    내용
                  </label>
                  <textarea
                    rows={4}
                    placeholder="예) 그림 동아리에서 신입 회원을 모집합니다. 매주 수요일 오후 3시, 미술실."
                    defaultValue={table.text}
                    className={this.inputCls + " resize-y"}
                    onChange={event => this.handleChange(event, index, "text")}
                  />
                </div>
              ))}
            </div>

            <button
              type="button"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-sky-300 bg-sky-50 px-4 py-3 text-sm font-bold text-sky-600 transition hover:bg-sky-100 sm:ml-9 sm:w-auto"
              onClick={() => this.addHeader()}
            >
              + 항목 추가
            </button>
          </section>
            </div>

            {/* 실시간 앱 미리보기 */}
            <div className="w-full lg:w-[340px] lg:shrink-0">
              <div className="lg:sticky lg:top-4">
                <NewsletterPhonePreview
                  pageNames={this.props.pageNames}
                  date={this.props.obj[0].date}
                  noOfWeeks={this.props.obj[0].noOfWeeks}
                  magazine={{
                    page1: this.props.obj[0].magazine1.page1,
                    page2: this.state.headers,
                    page3: this.props.obj[0].magazine1.page3
                  }}
                  activePage={1}
                />
              </div>
            </div>
          </div>

          {/* 하단 네비게이션 */}
          <div className="flex items-center justify-between gap-3">
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50"
              onClick={() => this.props.changePage(this.state.headers, "previous")}
            >
              ← 이전 단계
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-xl bg-sky-500 px-6 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-sky-600"
              onClick={() => this.props.changePage(this.state.headers, "next")}
            >
              다음 단계로 →
            </button>
          </div>
        </div>
      </div>
    );
  }
}
